
// New On Cop img
import upcoming1 from "../../../assets/images/upcoming/01.jpg";
import upcoming2 from "../../../assets/images/upcoming/02.jpg";
import upcoming3 from "../../../assets/images/upcoming/03.jpg";
import upcoming4 from "../../../assets/images/upcoming/04.jpg";
import upcoming5 from "../../../assets/images/upcoming/05.jpg";


// top rating images
import top1 from "../../../assets/images/Top-ratings/top-1.png"
import top2 from "../../../assets/images/Top-ratings/top-2.png"
import top3 from "../../../assets/images/Top-ratings/top-3.png"
import top4 from "../../../assets/images/Top-ratings/top-4.png"
import top5 from "../../../assets/images/Top-ratings/top-5.png"
import top6 from "../../../assets/images/Top-ratings/top-6.png"
import top7 from "../../../assets/images/Top-ratings/top-7.png"
import top8 from "../../../assets/images/Top-ratings/top-8.png"
import top9 from "../../../assets/images/Top-ratings/top-9.png"
import top10 from "../../../assets/images/Top-ratings/top-10.png"

// live 

//news

import news1 from "../../../assets/images/Live/Live_News/1.png"
import news2 from "../../../assets/images/Live/Live_News/2.png"
import news3 from "../../../assets/images/Live/Live_News/3.png"
import news4 from "../../../assets/images/Live/Live_News/4.png"

// music

import music1 from "../../../assets/images/Live/Live_Music/1.png"
import music2 from "../../../assets/images/Live/Live_Music/2.png"
import music3 from "../../../assets/images/Live/Live_Music/3.png"
import music4 from "../../../assets/images/Live/Live_Music/4.png"
import music5 from "../../../assets/images/Live/Live_Music/5.png"
import music6 from "../../../assets/images/Live/Live_Music/6.png"
import music7 from "../../../assets/images/Live/Live_Music/7.png"
import music8 from "../../../assets/images/Live/Live_Music/8.png"
import music9 from "../../../assets/images/Live/Live_Music/9.png"
import music10 from "../../../assets/images/Live/Live_Music/10.png"

// sports

import sports1 from "../../../assets/images/Live/Live_Sports/1.png"
import sports2 from "../../../assets/images/Live/Live_Sports/2.png"
import sports3 from "../../../assets/images/Live/Live_Sports/3.png"
import sports4 from "../../../assets/images/Live/Live_Sports/4.png"
import sports5 from "../../../assets/images/Live/Live_Sports/5.png"




export  const newOnCopepod = [
    {
      title: "The Last Breath",
      imageUrl: upcoming1,  
      ageRating: "5+",
      duration: "2h 30m",
    },
    {
      title: "Shadow",
      imageUrl: upcoming2,   
      ageRating: "22+",
      duration: "2h 15m",
    },
    {
      title: "Another Danger",
      imageUrl: upcoming3,  
      ageRating: "25+",
      duration: "3h",
    },
    {
      title: "1980",
      imageUrl: upcoming4,  
      ageRating: "11+",
      duration: "2h 45m",
    },
    {
      title: "Vugotronic",
      imageUrl: upcoming5, 
      ageRating: "9+",
      duration: "2h 30m",
    },
  ];

  export  const Top10ShowsInUS = [
    {
      topImg: top1,
      title: "The Last Breath",
      imageUrl: upcoming1,  
      ageRating: "5+",
      duration: "2h 30m",
    },
    {
      topImg: top2,
      title: "Shadow",
      imageUrl: upcoming2,   
      ageRating: "22+",
      duration: "2h 15m",
    },
    {
      topImg: top3,
      title: "Another Danger",
      imageUrl: upcoming4,  
      ageRating: "25+",
      duration: "3h",
    },
    {
      topImg: top4,
      title: "Another Danger",
      imageUrl: upcoming4,  
      ageRating: "25+",
      duration: "3h",
    },
    {
      topImg: top5,
      title: "Another Danger",
      imageUrl: upcoming4,  
      ageRating: "25+",
      duration: "3h",
    },
    {
      topImg: top6,
      title: "Vugotronic",
      imageUrl: upcoming5, 
      ageRating: "9+",
      duration: "2h 30m",
    },
    {
      topImg: top7,
      title: "Shadow",
      imageUrl: upcoming2,   
      ageRating: "22+",
      duration: "2h 15m",
    },
    {
      topImg: top8,
      title: "Another Danger",
      imageUrl: upcoming4,  
      ageRating: "25+",
      duration: "3h",
    },
    {
      topImg: top9,
      title: "1980",
      imageUrl: upcoming4,  
      ageRating: "11+",
      duration: "2h 45m",
    },
    {
      topImg: top10,
      title: "Vugotronic",
      imageUrl: upcoming5, 
      ageRating: "9+",
      duration: "2h 30m",
    },
  ];


  //live 

  export  const LiveNewsChannel = [
    {
      title: "News HD",
      imageUrl: news1,  
      liveStatus: true,
    },
    {
      title: "Live News",
      imageUrl: news2,  
      liveStatus: true,
    },
    {
      title: "Flash News HD",
      imageUrl: news3,  
      liveStatus: true,
    },
    {
      title: "News Live",
      imageUrl: news4,  
      liveStatus: true,
    },
   
  ];


  //music

  export  const LiveMusicChannel = [
    {
      title: "Records",
      imageUrl: music1,  
      liveStatus: true,
    },
    {
      title: "play Sounds",
      imageUrl: music2,  
      liveStatus: true,
    },
    {
      title: "Loud Sound",
      imageUrl: music3,  
      liveStatus: true,
    },
    {
      title: "Music Collections",
      imageUrl: music4,  
      liveStatus: true,
    },
    {
      title: "Xter",
      imageUrl: music5,  
      liveStatus: true,
    },
    {
      title: "Music Mix",
      imageUrl: music6,  
      liveStatus: true,
    },
    {
      title: "Best Sound",
      imageUrl: music7,  
      liveStatus: true,
    },
    {
      title: "Music Beat",
      imageUrl: music8,  
      liveStatus: true,
    },
    {
      title: "DJ Techno",
      imageUrl: music9,  
      liveStatus: true,
    },
    {
      title: "Music Collection",
      imageUrl: music10,  
      liveStatus: true,
    },
   
  ];


  //Sports

  export  const LiveSportsChannel = [
    {
      title: "Sports HD",
      imageUrl: sports1,  
      liveStatus: true,
    },
    {
      title: "Player Fire",
      imageUrl: sports2,  
      liveStatus: true,
    },
    {
      title: "Net Ball Club",
      imageUrl: sports3,  
      liveStatus: true,
    },
    {
      title: "Dice Adventure",
      imageUrl: sports4,  
      liveStatus: true,
    },
    {
      title: "Finder Sports",
      imageUrl: sports5,  
      liveStatus: true,
    },
    {
      title: "Music Mix",
      imageUrl: music6,  
      liveStatus: true,
    },
    {
      title: "Best Sound",
      imageUrl: music7,  
      liveStatus: true,
    },
    {
      title: "Music Beat",
      imageUrl: music8,  
      liveStatus: true,
    },
    {
      title: "DJ Techno",
      imageUrl: music9,  
      liveStatus: true,
    },
    {
      title: "Music Collection",
      imageUrl: music10,  
      liveStatus: true,
    },
   
  ];